import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X } from "lucide-react";
import { Panel } from "@/components/common";
import { useMember } from "@/context/MemberContext";

const STEPS = [
  { key: "has_team", title: "Voeg je team toe", text: "Deel de uitnodigingscode of maak accounts aan.", to: "/medewerkers" },
  { key: "has_shifts", title: "Plan je eerste week", text: "Klik in de planning op een vakje om een dienst toe te voegen.", to: "/planning" },
  { key: "has_messages", title: "Plaats een welkomstbericht", text: "Laat je team weten dat jullie nu ShiftMate gebruiken.", to: "/prikbord" },
  { key: "has_entries", title: "Test het klokken", text: "Klok in en uit om te zien hoe het werkt.", to: "/klokken" },
];

export const OwnerChecklist = ({ setup }) => {
  const { member, business } = useMember();
  const key = `sm-checklist-hidden-${business.id}-${member.user_id}`;
  const [hidden, setHidden] = useState(localStorage.getItem(key) === "1");
  const done = STEPS.filter((s) => setup[s.key]).length;
  if (hidden || done === STEPS.length) return null;
  const hide = () => {
    localStorage.setItem(key, "1");
    setHidden(true);
  };
  return (
    <Panel className="mb-6 border-[#0D5C46]/30 fade-up" data-testid="owner-checklist">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="font-semibold text-lg">Aan de slag: {done} van {STEPS.length} klaar</h2>
          <p className="text-sm text-slate-500">Doorloop deze stappen om je zaak in 10 minuten klaar te zetten.</p>
        </div>
        <button onClick={hide} className="p-1 text-slate-400 hover:text-slate-700" aria-label="Verbergen" data-testid="owner-checklist-hide"><X className="h-4 w-4" /></button>
      </div>
      <ol className="mt-4 grid sm:grid-cols-2 gap-2">
        {STEPS.map((s, i) => (
          <li key={s.key}>
            <Link to={s.to} className="flex gap-3 rounded-xl border border-slate-200 p-3 hover:bg-slate-50 transition-colors" data-testid={`checklist-step-${s.key}`}>
              {setup[s.key] ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <Circle className="h-5 w-5 text-slate-300 shrink-0" />}
              <span>
                <span className={`block text-sm font-semibold ${setup[s.key] ? "line-through text-slate-400" : ""}`}>{i + 1}. {s.title}</span>
                <span className="block text-xs text-slate-500">{s.text}</span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </Panel>
  );
};
